import * as React  from "react";
import { useState } from "react";

const getCsrfToken = () => {
  const meta = document.querySelector('meta[name=csrf-token');
  if (meta instanceof HTMLMetaElement) {
    return meta.content;
  }
  return '';
}

const AUTO_SEND_ENABLED = { DISABLE: 0, ENABLE: 1 }

const AutoSendSetting = (props) => {
  return(
    <div className="mt40">
      <h3>自動送信設定</h3>
      <br />
      <form name="messages_update_form" action="/messages/update_auto_send_enabled" acceptCharset="UTF-8" method="post">
        <input name="utf8" type="hidden" value="✓" />
        <input name="authenticity_token" type="hidden" value={getCsrfToken()} />
        {props.paymentCompletionTemplate ? (
          <div className="form-group">
            <label style={{ marginLeft: '20px', width: '200px' }}>{props.paymentCompletionTemplate.message_name}</label>
            <div className="radio-inline">
              <input type="radio"
                name="payment_completion_message_auto_send"
                id="payment_completion_message_auto_send_1"
                value={AUTO_SEND_ENABLED.ENABLE}
                onChange={e => props.setPaymentCompletionTemplate({ ...props.paymentCompletionTemplate, auto_send_enabled: e.target.value })}
                checked={parseInt(props.paymentCompletionTemplate.auto_send_enabled) === AUTO_SEND_ENABLED.ENABLE}
                className="radio-input" />
              <label htmlFor="payment_completion_message_auto_send_1">送信する</label>
            </div>
            <div className="radio-inline">
              <input type="radio"
                name="payment_completion_message_auto_send"
                id="payment_completion_message_auto_send_0"
                value={AUTO_SEND_ENABLED.DISABLE}
                onChange={e => props.setPaymentCompletionTemplate({ ...props.paymentCompletionTemplate, auto_send_enabled: e.target.value })}
                checked={parseInt(props.paymentCompletionTemplate.auto_send_enabled) === AUTO_SEND_ENABLED.DISABLE}
                className="radio-input" />
              <label htmlFor="payment_completion_message_auto_send_0">送信しない</label>
            </div>
          </div>
        ) : null}
        {props.paymentFailedTemplate ? (
          <div className="form-group">
            <label style={{ marginLeft: '20px', width: '200px' }}>{props.paymentFailedTemplate.message_name}</label>
            <div className="radio-inline">
              <input type="radio"
                name="payment_failed_message_auto_send"
                id="payment_failed_message_auto_send_1"
                value={AUTO_SEND_ENABLED.ENABLE}
                onChange={e => props.setPaymentFailedTemplate({ ...props.paymentFailedTemplate, auto_send_enabled: e.target.value })}
                checked={parseInt(props.paymentFailedTemplate.auto_send_enabled) === AUTO_SEND_ENABLED.ENABLE}
                className="radio-input" />
              <label htmlFor="payment_failed_message_auto_send_1">送信する</label>
            </div>
            <div className="radio-inline">
              <input type="radio"
                name="payment_failed_message_auto_send"
                id="payment_failed_message_auto_send_0"
                value={AUTO_SEND_ENABLED.DISABLE}
                onChange={e => props.setPaymentFailedTemplate({ ...props.paymentFailedTemplate, auto_send_enabled: e.target.value })}
                checked={parseInt(props.paymentFailedTemplate.auto_send_enabled) === AUTO_SEND_ENABLED.DISABLE}
                className="radio-input" />
              <label htmlFor="payment_failed_message_auto_send_0">送信しない</label>
            </div>
          </div>
        ) : null}
        {props.paymentInProcessTemplate ? (
          <div className="form-group">
            <label style={{ marginLeft: '20px', width: '200px' }}>{props.paymentInProcessTemplate.message_name}</label>
            <div className="radio-inline">
              <input type="radio"
                name="payment_in_process_message_auto_send"
                id="payment_in_process_message_auto_send_1"
                value={AUTO_SEND_ENABLED.ENABLE}
                onChange={e => props.setPaymentInProcessTemplate({ ...props.paymentInProcessTemplate, auto_send_enabled: e.target.value })}
                checked={parseInt(props.paymentInProcessTemplate.auto_send_enabled) === AUTO_SEND_ENABLED.ENABLE}
                className="radio-input" />
              <label htmlFor="payment_in_process_message_auto_send_1">送信する</label>
            </div>
            <div className="radio-inline">
              <input type="radio"
                name="payment_in_process_message_auto_send"
                id="payment_in_process_message_auto_send_0"
                value={AUTO_SEND_ENABLED.DISABLE}
                onChange={e => props.setPaymentInProcessTemplate({ ...props.paymentInProcessTemplate, auto_send_enabled: e.target.value })}
                checked={parseInt(props.paymentInProcessTemplate.auto_send_enabled) === AUTO_SEND_ENABLED.DISABLE}
                className="radio-input" />
              <label htmlFor="payment_in_process_message_auto_send_0">送信しない</label>
            </div>
          </div>
        ) : null}
        {props.videoStartTemplate ? (
          <div className="form-group">
            <div style={{display: 'inline-block', verticalAlign: 'top', height: '31px' }}>
              <label style={{ marginLeft: '20px', width: '200px', verticalAlign: 'sub' }}>{props.videoStartTemplate.message_name}</label>
            </div>
            <div style={{display: 'inline-block'}}>
              <div className="radio-inline">
                <input type="radio"
                  name="video_start_message_auto_send"
                  id="video_start_message_auto_send_1"
                  value={AUTO_SEND_ENABLED.ENABLE}
                  onChange={e => props.setVideoStartTemplate({ ...props.videoStartTemplate, auto_send_enabled: e.target.value })}
                  checked={parseInt(props.videoStartTemplate.auto_send_enabled) === AUTO_SEND_ENABLED.ENABLE}
                  className="radio-input" />
                <label htmlFor="video_start_message_auto_send_1">送信する</label>
              </div>
              <div className="radio-inline">
                <input type="radio"
                       name="video_start_message_auto_send"
                       id="video_start_message_auto_send_0"
                       value={AUTO_SEND_ENABLED.DISABLE}
                       onChange={e => props.setVideoStartTemplate({ ...props.videoStartTemplate, auto_send_enabled: e.target.value })}
                       checked={parseInt(props.videoStartTemplate.auto_send_enabled) === AUTO_SEND_ENABLED.DISABLE}
                       className="radio-input" />
                <label htmlFor="video_start_message_auto_send_0">送信しない</label>
              </div>
              <div className="mt10">
                <label style={{ marginLeft: '20px' }}>送信時刻:</label>
                <select
                  className="form-control"
                  style={{ width: '150px', display: 'inline-block', marginLeft: '20px' }}
                  name="video_start_message_remind_time"
                  onChange={e => props.setVideoStartTemplate({ ...props.videoStartTemplate, video_start_remind_time: e.target.value })}
                  value={props.videoStartTemplate.video_start_remind_time || 15}
                  disabled={parseInt(props.videoStartTemplate.auto_send_enabled) === AUTO_SEND_ENABLED.DISABLE}
                >
                  {Object.entries(props.videoStartRemindTimeOptions).map((time, i) => (
                    <option key={i} value={time[1].toString()}>{time[0]}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        ) : null}
        <input type="submit" name="" value="更新する" className="btn btn-primary pull-right" data-disable-with="更新する" />
      </form>
    </div>
  );
}

export default AutoSendSetting
